@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.pilates.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.pilates.composeapp.generated.resources/"

@delegate:ResourceContentHash(736_684_373)
internal val Res.drawable.bg_meal_plan_card: DrawableResource by lazy {
      DrawableResource("drawable:bg_meal_plan_card", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/bg_meal_plan_card.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/bg_meal_plan_card.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/bg_meal_plan_card.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_412_856_818)
internal val Res.drawable.bg_workouts_topbar: DrawableResource by lazy {
      DrawableResource("drawable:bg_workouts_topbar", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/bg_workouts_topbar.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/bg_workouts_topbar.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/bg_workouts_topbar.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_859_493_881)
internal val Res.drawable.ic_calendar_clock: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar_clock", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar_clock.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_789_067_751)
internal val Res.drawable.ic_checkmark_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_checked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-932_290_427)
internal val Res.drawable.ic_checkmark_unchecked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_unchecked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_unchecked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(449_530_494)
internal val Res.drawable.ic_home: DrawableResource by lazy {
      DrawableResource("drawable:ic_home", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(160_044_452)
internal val Res.drawable.ic_scroll_content: DrawableResource by lazy {
      DrawableResource("drawable:ic_scroll_content", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_scroll_content.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_752_121_504)
internal val Res.drawable.ic_speechbubble_text: DrawableResource by lazy {
      DrawableResource("drawable:ic_speechbubble_text", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_speechbubble_text.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-463_222_031)
internal val Res.drawable.ic_splash: DrawableResource by lazy {
      DrawableResource("drawable:ic_splash", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_splash.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(910_217_769)
internal val Res.drawable.ic_user: DrawableResource by lazy {
      DrawableResource("drawable:ic_user", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_user.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_241_506_164)
internal val Res.drawable.img_water_footer: DrawableResource by lazy {
      DrawableResource("drawable:img_water_footer", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_water_footer.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_water_footer.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_water_footer.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("bg_meal_plan_card", Res.drawable.bg_meal_plan_card)
  map.put("bg_workouts_topbar", Res.drawable.bg_workouts_topbar)
  map.put("ic_calendar_clock", Res.drawable.ic_calendar_clock)
  map.put("ic_checkmark_checked", Res.drawable.ic_checkmark_checked)
  map.put("ic_checkmark_unchecked", Res.drawable.ic_checkmark_unchecked)
  map.put("ic_home", Res.drawable.ic_home)
  map.put("ic_scroll_content", Res.drawable.ic_scroll_content)
  map.put("ic_speechbubble_text", Res.drawable.ic_speechbubble_text)
  map.put("ic_splash", Res.drawable.ic_splash)
  map.put("ic_user", Res.drawable.ic_user)
  map.put("img_water_footer", Res.drawable.img_water_footer)
}
